export class CaptureLongStayRateCommand {
	superhogUserId: string;
	pricingCardTypeId: number;
	/** Null = an all-levels row for the basis; set = an override for that one level. */
	protectionLevelId?: number | null;
	currencyId: number;
	/** Null with rate = "No long stay", allowed only with a level. */
	nightThreshold: number | null;
	rate: number | null;
	startDate?: string;
}
